require("./js/docking-bar.js");
require("./scss/docking-bar.scss");